import React, { Fragment, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import toast from 'react-hot-toast'
import ReactQuill from 'react-quill'
import { Card, CardBody, CardFooter, CardTitle, Col, Input, Row, Spinner } from 'reactstrap'
import { SettingsService } from '../../../modules/Services/Settings'
import CopyClipboard from '../../../modules/commonModel/CopyClipboard'

function EmailTemplates() {
    const entity_id = localStorage.getItem('entity_id')
    const [template, setTemplate] = useState(null)
    const [loader, setLoader] = useState('')

    const handleTemplate = (field: string, value: any) => {
        setTemplate((pre: any) => ({ ...pre, [field]: value }))
    }

    useEffect(() => {
        SettingsService.getEmailTemplate(entity_id)
            .then((res: any) => {
                setTemplate(res?.data?.response)
            })
            .catch((err: any) => {
                toast.error(err?.response?.data?.message)
            })
    }, [])

    const saveTemplate = () => {
        setLoader('save')

        SettingsService.updateEmailTemplate(entity_id, template)
            .then((res: any) => {
                toast.success(res?.data?.message)
            })
            .catch((err: any) => {
                toast.error(err?.response?.data?.message)
            })
            .finally(() => setLoader(''))
    }

    return (
        <Fragment>
            <Card className='mb-5'>
                <CardBody>
                    <Row>
                        <Col md='6'>
                            <CardTitle className='dropdown-header mb-3'>Booking Confirmation</CardTitle>
                            <ReactQuill
                                theme="snow"
                                value={template?.booking_confirmation}
                                onChange={(value) => handleTemplate('booking_confirmation', value)}
                                modules={{
                                    toolbar: {
                                        container: [
                                            [{ header: [1, 2, 3, 4, false] }],
                                            ["bold", "italic", "underline"],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            ["link", "image"],
                                            ["blockquote"]
                                        ]
                                    },
                                }}
                                formats={[
                                    "header",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strike",
                                    "list",
                                    "bullet",
                                    "link",
                                    "image",
                                    'blockquote'
                                ]}
                            />
                            <Row className='my-5'>
                                <div className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        className="me-2"
                                        checked={template?.is_booking_bcc}
                                        onChange={(e) => handleTemplate('is_booking_bcc', e.target.checked)}
                                    />
                                    <label className="mb-0">BCC Email</label>
                                </div>
                                <div className='mt-4'>
                                    <Input type="text"
                                        className='w-50'
                                        placeholder='BCC Email'
                                        value={template?.booking_bcc}
                                        onChange={(e) => handleTemplate('booking_bcc', e.target.value)}
                                    />
                                </div>
                            </Row>
                            <div className='d-flex mt-5'>
                                <div>
                                    <CopyClipboard
                                        text={`{{client_name}}`}
                                        id="client-name"
                                    />
                                </div>
                                <div className='mx-10'>
                                    <CopyClipboard
                                        text={`{{booking_number}}`}
                                        id="booking-number"
                                    />
                                </div>
                                <div>
                                    <CopyClipboard
                                        text={`{{booking_detail}}`}
                                        id="booking-number"
                                    />
                                </div>
                                <div className='mx-10'>
                                    <CopyClipboard
                                        text={`{{notes}}`}
                                        id="notes"
                                    />
                                </div>
                                <div>
                                    <CopyClipboard
                                        text={`{{rate}}`}
                                        id="rate"
                                    />
                                </div>
                            </div>
                        </Col>
                        <Col md='6'>
                            <CardTitle className='dropdown-header mb-3'>Invoice Issue</CardTitle>
                            <ReactQuill
                                theme="snow"
                                value={template?.invoice_issue}
                                onChange={(value) => handleTemplate('invoice_issue', value)}
                                modules={{
                                    toolbar: {
                                        container: [
                                            [{ header: [1, 2, 3, 4, false] }],
                                            ["bold", "italic", "underline"],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            ["link", "image"],
                                            ["blockquote"]
                                        ]
                                    },
                                }}
                                formats={[
                                    "header",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strike",
                                    "list",
                                    "bullet",
                                    "link",
                                    "image"
                                ]}
                            />
                            <Row className='my-5'>
                                <div className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        className="me-2"
                                        checked={template?.is_invoice_bcc}
                                        onChange={(e) => handleTemplate('is_invoice_bcc', e.target.checked)}
                                    />
                                    <label className="mb-0">BCC Email</label>
                                </div>
                                <div className='mt-4'>
                                    <Input type="text"
                                        className='w-50'
                                        placeholder='BCC Email'
                                        value={template?.invoice_bcc}
                                        onChange={(e) => handleTemplate('invoice_bcc', e.target.value)}
                                    />
                                </div>
                            </Row>
                            <div className='d-flex mt-5'>
                                <div className='me-10'>
                                    <CopyClipboard
                                        text={`{{client_name}}`}
                                        id="client-name"
                                    />
                                </div>
                                <div>
                                    <CopyClipboard
                                        text={`{{payment_link}}`}
                                        id="payment-link"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col md='6'>
                            <CardTitle className='dropdown-header mb-3'>Deposit Request</CardTitle>
                            <ReactQuill
                                theme="snow"
                                value={template?.deposit_request}
                                onChange={(value) => handleTemplate('deposit_request', value)}
                                modules={{
                                    toolbar: {
                                        container: [
                                            [{ header: [1, 2, 3, 4, false] }],
                                            ["bold", "italic", "underline"],
                                            [{ list: "ordered" }, { list: "bullet" }],
                                            ["link", "image"],
                                            ["blockquote"]
                                        ]
                                    },
                                }}
                                formats={[
                                    "header",
                                    "bold",
                                    "italic",
                                    "underline",
                                    "strike",
                                    "list",
                                    "bullet",
                                    "link",
                                    "image"
                                ]}
                            />
                            <Row className='my-5'>
                                <div className="d-flex align-items-center">
                                    <Input type="checkbox"
                                        className="me-2"
                                        checked={template?.is_deposit_bcc}
                                        onChange={(e) => handleTemplate('is_deposit_bcc', e.target.checked)}
                                    />
                                    <label className="mb-0">BCC Email</label>
                                </div>
                                <div className='mt-4'>
                                    <Input type="text"
                                        className='w-50'
                                        placeholder='BCC Email'
                                        value={template?.deposit_bcc}
                                        onChange={(e) => handleTemplate('deposit_bcc', e.target.value)}
                                    />
                                </div>
                            </Row>
                            <div className='d-flex mt-5'>
                                <div>
                                    <CopyClipboard
                                        text={`{{client_name}}`}
                                        id="client-name"
                                    />
                                </div>
                                <div className='mx-10'>
                                    <CopyClipboard
                                        text={`{{deposit_amount}}`}
                                        id="deposit-amount"
                                    />
                                </div>
                                <div>
                                    <CopyClipboard
                                        text={`{{payment_link}}`}
                                        id="payment-link"
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </CardBody>
                <CardFooter className='p-4'>
                    <div className='d-flex justify-content-end'>
                        <Button type='button' size='sm' color='primary' disabled={loader === 'save'} onClick={saveTemplate}>
                            {loader === 'save' ? <Spinner size='sm' /> : <span className='align-middle d-sm-inline-block d-none'>Save</span>}
                        </Button>
                    </div>
                </CardFooter>
            </Card >
        </Fragment >
    )
}

export default EmailTemplates